module.exports = __webpack_public_path__ + "static/media/home4.8d39f71e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/home/carousel-gallery/images/home4.jpg
// module id = 649
// module chunks = 0